<template>
  <div class="partner-page">
    <Header />
    
    <div class="partner-container">
      <!-- 介绍文字 -->
      <div class="partner-introduction">
        <h2 class="section-title">合作伙伴</h2>
        <p class="intro-text">
          chmura云通讯一直以来致力于为企业提供高效、稳定的云通讯解决方案，经过多年的发展，我们已经与超过2000家企业建立了紧密的合作关系。这些合作伙伴遍布全国31个省份和直辖市，涵盖了金融、教育、医疗、制造、零售等多个行业领域。
        </p>
        <p class="intro-text">
          我们的客户包括世界500强企业、知名互联网公司、大型国企以及快速成长的创业公司。通过与这些优秀企业的合作，我们不断优化产品和服务，提升技术创新能力，为客户创造更大的价值。
        </p>
        <p class="intro-text">
          在合作过程中，我们始终坚持以客户为中心的原则，深入了解每个行业的特点和需求，提供量身定制的解决方案。我们的服务团队拥有丰富的行业经验，能够快速响应客户需求，确保服务质量和交付效率。
        </p>
        <p class="intro-text">
          未来，我们将继续扩大合作伙伴网络，加强与各行业客户的深度合作，共同推动数字化转型和智能通讯的发展。我们相信，通过不断创新和优化，chmura云通讯将成为更多企业值得信赖的云通讯合作伙伴。
        </p>
      </div>

      <!-- 照片墙 -->
      <div class="partner-photo-wall">
        <h3 class="section-subtitle">合作伙伴展示</h3>
        <div class="photo-grid">
          <div 
            v-for="(item, index) in 40" 
            :key="index"
            class="partner-item"
          >
            <img 
              :src="getRandomImage()" 
              :alt="`合作伙伴${index + 1}`"
              class="partner-image"
              @error="handleImageError"
            >
            <div class="partner-name">{{ getRandomCompanyName() }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import BackToTop from '../components/BackToTop.vue'
import { partnerCompanies } from './config.js'

export default {
  name: 'Partner',
  components: {
    Header,
    Footer,
    BackToTop
  },
  data() {
    return {
      // 存储生成的图片URL，避免重复生成
      imageCache: []
    }
  },
  methods: {
    // 生成随机图片URL
    getRandomImage() {
      if (this.imageCache.length < 40) {
        const width = 80;
        const height = 80;
        const imageUrl = `https://picsum.photos/seed/${Date.now() + this.imageCache.length}/${width}/${height}`;
        this.imageCache.push(imageUrl);
        return imageUrl;
      }
      return this.imageCache[Math.floor(Math.random() * this.imageCache.length)];
    },
    // 生成随机公司名称
    getRandomCompanyName() {
      const randomIndex = Math.floor(Math.random() * partnerCompanies.length);
      return partnerCompanies[randomIndex];
    },
    // 处理图片加载错误
    handleImageError(event) {
      console.error('图片加载失败:', event);
    }
  }
}
</script>

<style scoped>
.partner-page {
  padding-top: 80px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.partner-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.partner-introduction {
  background-color: #fff;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 40px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
  text-align: center;
  background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.intro-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #606266;
  margin-bottom: 16px;
  text-align: justify;
}

.partner-photo-wall {
  background-color: #fff;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.section-subtitle {
  font-size: 1.8rem;
  font-weight: bold;
  color: #303133;
  margin-bottom: 30px;
  text-align: center;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 20px;
  justify-items: center;
}

.partner-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
}

.partner-item:hover {
  background-color: #f0f9ff;
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);
}

.partner-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 8px;
  border: 2px solid #e4e7ed;
  transition: all 0.3s ease;
}

.partner-item:hover .partner-image {
  border-color: #409EFF;
  transform: scale(1.1);
  box-shadow: 0 0 10px rgba(64, 158, 255, 0.5);
}

.partner-name {
  font-size: 0.9rem;
  color: #606266;
  text-align: center;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .partner-introduction,
  .partner-photo-wall {
    padding: 20px;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .section-subtitle {
    font-size: 1.5rem;
  }
  
  .intro-text {
    font-size: 1rem;
  }
  
  .photo-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 15px;
  }
}

@media (max-width: 480px) {
  .photo-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 10px;
  }
  
  .partner-image {
    width: 35px;
    height: 35px;
  }
  
  .partner-name {
    font-size: 0.8rem;
  }
}
</style>